// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__14lky","footer":"ChangeClinic_footer__DEz_z"};